module.exports = __webpack_public_path__ + "static/media/programme_slogan_hu.3e0e83dc.png";